"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var layout_1 = require("../../../../layout");
var styles = {
    container: react_1.css({
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
    }),
    content: react_1.css({
        flex: 1,
        overflow: 'auto',
    }),
};
var TopBarLayout = function (_a) {
    var children = _a.children;
    return (react_1.jsx(layout_1.Flex, { direction: "column", css: styles.container }, children));
};
TopBarLayout.displayName = 'TopBar.Layout';
var TopBarLayoutContent = function (_a) {
    var children = _a.children;
    return (react_1.jsx("div", { css: styles.content }, children));
};
TopBarLayoutContent.displayName = 'TopBar.Layout.Content';
exports.default = Object.assign(TopBarLayout, { Content: TopBarLayoutContent });
